import { Component, ChangeDetectorRef, QueryList, ViewChildren } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ExcelService } from '../../../services/excel/excel.service';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { FiltersM,typesApex } from '../../../components/models';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { SegPresupuestalService } from '../../../services/segimiento-presupuestal/seg-presupuestal.service';
import { obtenerIds } from '../idsTabla';
import { companiesSegPresupuestal } from '../../../shared/catalogos';
import { cuentaEntity, detalleCuentaEntity, evaluacionesAllEntity, sucursalesEntity, varTipoEntity } from '../../../services/segimiento-presupuestal/Manual/entities';
import { Periodos } from '../funcionesFormuladorSeguimiento';


@Component({
  selector: 'app-estados-financieros',
  templateUrl: './estados-financieros.component.html',
  styleUrl: './estados-financieros.component.css'
})
export class EstadosFinancierosComponent {
  public Filters = FiltersM;
  public escenarios: any[] = [];
  public escenariosShow: any[] = [];
  public todosEscenarios: boolean = true;
  public escenarioSeleccionado;

  public sucursales: any[] = [];
  public consolidado: boolean = true;
  public sucursalSeleccionada;

  // Propiedades para períodos
  public Periodos: any[] = [];
  public periodoSeleccionado: any = null;

  // Propiedades para controles de análisis
  public perspectives = [{name: 'Vertical', check: false},
  ]
  public sinSaldo: boolean = false;
  public semaforo: boolean = false;
  public contraerExpandir: boolean = false; //false -> contraer todo   true -> expandir todo
  public metricaSeleccionada: string = 'Balance general';
  public balanceEstados: boolean = true; //true -> Balance general, false => estado de resultados

  // Propiedades para semáforos
  public semaforosVariacion: any[] = [];
  public semaforos: any[] = [];

  // Propiedades para institución y datos
  public instSelecc: any = { id: 0, alias: '' };
  private institucionId = undefined;
  private templateId = undefined;
  private idBase: number;
  public tagInstitucion: number;
  public miles = ',';
  public decimal = '.';
  public inst: any[] = [];
  public dataCuentaContable: any[] = [];
  public cuentaSelec = undefined;
  public cuentasJerarquicas: any[] = [];  
  public cuentasVisibles: any[] = [];
  public encMet = 1; //1 -> consolidado 2->Saldos y movimientos
  // Propiedades para gráfico
  public datoGrafico: any[] = [];
  public etiquetasGrafico: string[] = [];
  public coloresGrafico: string[] = ['#00255c', '#018fbf', '#8ad3e6']
  public coloresGraf2 = ['#5eade5', '#8ad2e6', '#a4d65d', '#ffe370', '#fdaf60', '#fb7598']
  public chartOptions: any = { plotOptions: { bar: { horizontal: true } } };
  public titGrafica: string = '';
  public ejes = true;
  // Propiedades para controles de gráfica
  public etiquetas: boolean = false;
  public changeLabel: boolean = false;
  public typeGrap = typesApex;
  public tipoGraficaActual: string = this.typeGrap.COMBO;
  // Propiedades control graficas de estructura
  public estructura: boolean = false;
  public estructuraR1 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.PIE, data: [], etiquetas:[]};
  public estructuraP1 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.PIE, data: [], etiquetas:[]};
  public estructuraR2 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.HEATMAP, data: [], etiquetas:[]};
  public estructuraP2 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.HEATMAP, data: [], etiquetas:[]};
  public estructuraR3 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.PIE, data: [], etiquetas:[]};
  public estructuraP3 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.PIE, data: [], etiquetas:[]};
  public tarjetasEstructura = [];
  public tituloModal: string = '';
  public subtituloModal: string = '';
  public modalOpen = false;
  public zonaAmpliada:number;
  public graficaAmp: number;
  @ViewChildren(GraficadorComponent) grafCmp!: QueryList<GraficadorComponent>;

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    public cookies: CookieService,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService,
    private segPresupuestalService: SegPresupuestalService,
  ) {
    this.institucionId = this.cookies.get('idInstitucion');
    this.idBase = companiesSegPresupuestal.find(i => i.id == this.institucionId).idBack;
    this.titGrafica = 'Evolución';
    this.personalizacion();
    this.initEscenarios();    
    this.initSucursales();
  }

  private personalizacion(){
    this.tagInstitucion = companiesSegPresupuestal.find( i => i.id == this.institucionId).etiquetas;
  }
  
  private async getCuentasContables() {
    if (!this.templateId) {
      this.dataCuentaContable = [];
      return;
    }
    try {
      let cuentaDesc: cuentaEntity = {plantillaId: this.templateId}
      let res: any = await firstValueFrom(this.segPresupuestalService.getCuentasDescripcion(cuentaDesc));
      let cuentaValor: detalleCuentaEntity = {idEvaluacion: this.periodoSeleccionado.idReal};
      const dataReal = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
      const idEvaEsce = this.escenariosShow.find(e => e.check);
      cuentaValor = {idEvaluacion: idEvaEsce.idPresupuesto};
      const dataPresupuesto = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
      let varsEntity: varTipoEntity = {plantillaId: this.templateId, tipoVariableId: 3} // 3 es por que representa las variables temporales
      const varsDesc = await firstValueFrom(this.segPresupuestalService.getVariableTipoDescripcion(varsEntity));
      varsEntity = {tipoVariableId: 3, evaluacionId: this.periodoSeleccionado.idReal};
      const varsReal = await firstValueFrom(this.segPresupuestalService.getVariableTipoValor(varsEntity));
      varsEntity = {tipoVariableId: 3, evaluacionId: idEvaEsce.idPresupuesto};
      const varsPresupuesto = await firstValueFrom(this.segPresupuestalService.getVariableTipoValor(varsEntity));
      res = [...res, ...varsDesc];

      //obtencion de movimientos del mes 
      const periodos = this.Periodos.flatMap(a => a.series);
      const indice = periodos.findIndex(p => p.check);
      const periodoAnterior =
        indice === -1
          ? null
          : periodos[indice].mes === 'ene'
            ? periodos[indice]
            : periodos[indice - 1];

      const evaluacionesAn = {plantillaId: this.templateId, periodo: periodoAnterior.periodo};
      const escenarioDisAn =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluacionesAn));
      const es = escenarioDisAn.filter(e => e.institucionId !== this.sucursalSeleccionada.id && e.institucion_entity.agrupadorId === this.sucursalSeleccionada.id)
      .map((e, i) => {
        return {
          name: e.institucion_entity.institucion.split(' | ')[1],
          check: i===0,
          idPresupuesto: e.id,
          ...e.institucion_entity
        }
      })
      .find(e => e.name === idEvaEsce.name);
      cuentaValor = {idEvaluacion: periodoAnterior.idReal};
      const dataRealMov = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
      cuentaValor = {idEvaluacion: es.idPresupuesto};
      const dataPresupuestoMov = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
      varsEntity = {evaluacionId: periodoAnterior.idReal};
      const varsRealMov = await firstValueFrom(this.segPresupuestalService.getVariableTipoValor(varsEntity));
      varsEntity = {evaluacionId: periodoAnterior.idPresupuesto};
      const varsPresMov = await firstValueFrom(this.segPresupuestalService.getVariableTipoValor(varsEntity));

      if (!res || res.length === 0) {
        this.dataCuentaContable = [];
        return;
      }

      // Generar semáforos para la institución actual
      this.generarSemaforosParaInstitucion();

      this.dataCuentaContable = res.map((r: any) => {
        let presupuesto, real, cumplimiento, cumplimientoMov, presupuestoMov, realMov;
        if(!r?.tipoVariableId){
          presupuesto = dataPresupuesto.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor > 0 
                ? Number((dataPresupuesto.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor).toFixed(2)) : '-';
          real = dataReal.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor > 0 
                ? dataReal.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor : '-';
          presupuestoMov = dataPresupuestoMov.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor > 0 
                ? dataPresupuestoMov.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor : '-';
            presupuestoMov = presupuestoMov !== '-' ? Number((presupuesto - presupuestoMov).toFixed(2)) : '-';
          realMov = dataRealMov.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor > 0 
                ? dataRealMov.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor : '-';
            realMov = realMov !== '-' ? Number((real - realMov).toFixed(2)) : '-';
        }else{
          let dataVReal = varsReal.find(i => i.code === r.code); 
          let dataVPres = varsPresupuesto.find(i => i.code === r.code); 
          let dataVRealMov = varsReal.find(i => i.code === r.code); 
          let dataVPresMov = varsPresupuesto.find(i => i.code === r.code); 
          if(dataVPres && dataVReal){
            presupuesto = dataVPres.valor > 0 ? Number((dataVPres.valor).toFixed(2)) : '-';
            real = dataVReal.valor > 0 ? dataVReal.valor : '-';
            if(dataVPresMov && dataVRealMov){
              presupuestoMov = dataVPresMov.valor > 0 ? dataVPresMov.valor : '-';
              presupuestoMov = presupuestoMov !== '-' ? Number((presupuesto-presupuestoMov).toFixed(2)) : '-';
              realMov = dataVRealMov.valor > 0 ? dataVRealMov.valor : '-';
              realMov = realMov !== '-' ? Number((real-realMov).toFixed(2)) : '-';
            }else{
              presupuesto = '-';
              real = '-';
              presupuestoMov = '-';
              realMov = '-';
              console.warn('No vay valores para el periodo anterior ' + r.code);
            }
          }else{
            presupuesto = '-';
            real = '-';
            console.warn('No vay valores para ' + r.code);
          }
        }
        cumplimiento = !isNaN((100 * real) / presupuesto) ? Number(((100 * real) / presupuesto).toFixed(2)) : '-';
        cumplimientoMov = !isNaN((100 * realMov) / presupuestoMov) ? Number(((100 * realMov) / presupuestoMov).toFixed(2)) : '-';        
        
        return {
          id: r.id,
          codigo: r.code,
          nombre: r.cuenta ?? r.variable,
          nivel: 0,
          cuentaPadre: r.cuentaPadreId ?? -1,
          hijos: [],
          expandido: false,
          visible: true,
          presupuesto: presupuesto,
          real: real,
          variacion: this.calcularVariacion(presupuesto, real),
          cumplimiento: cumplimiento,
          analisisVerticalPresupuesto: 0,
          analisisVerticalReal: 0,
          presupuestoMov: presupuestoMov,
          realMov: realMov,
          variacionMov: this.calcularVariacion(presupuestoMov, realMov),
          cumplimientoMov: cumplimientoMov,
          analisisVerticalPresupuestoMov: 0,
          analisisVerticalRealMov: 0
        };
      });
      this.organizarJerarquia();
      this.cuentaSelec = this.cuentasVisibles[0];
      this.prepararDatosGrafico();
      this.graficasEstructura();
    } catch (e) {
      messages.errorMessageGraph(e);
    }
  }
  private organizarJerarquia() {
    const plantilla = this.templateId === 4 ? 'idsCuentasP4' : '';
    const tabla = this.balanceEstados ? 'balance' : 'estados';

    const cuentasOrdenadas = this.dataCuentaContable
      .map(cuenta => {
        const config = obtenerIds[plantilla]?.(cuenta.codigo, tabla)?.[0];

        return {
          cuenta,
          nivel: config?.nivel,
          pos: config?.pos
        };
      })
      .filter(item => item.nivel !== undefined && item.pos !== undefined)
      .sort((a, b) => a.pos - b.pos || a.cuenta.codigo.localeCompare(b.cuenta.codigo));

    const cuentasRaiz: any[] = [];
    const pila: any[] = [];

    cuentasOrdenadas.forEach(({ cuenta, nivel }) => {
      const nodo = {
        ...cuenta,
        nivel,
        hijos: [],
        expandido: false,
        visible: true
      };

      // El último nodo con nivel menor es el padre.
      while (pila.length > 0 && pila[pila.length - 1].nivel >= nivel) {
        pila.pop();
      }

      const padre = pila[pila.length - 1];

      if (padre) {
        padre.hijos.push(nodo);
        nodo.visible = false;
      } else {
        cuentasRaiz.push(nodo);
      }

      pila.push(nodo);
    });

    this.cuentasJerarquicas = cuentasRaiz;
    this.generarAnalisisVertical();
    this.expandirTodo();
  }
  private expandirTodo() {
    const recorrer = (cuentas:any[]) => {
      cuentas.forEach(cuenta => {
        cuenta.expandido = true;
        if(cuenta.nivel > 2){
          recorrer(cuenta.hijos);
        }
      });
    }
    recorrer(this.cuentasJerarquicas);
    this.actualizarCuentasVisibles();
  } 

  private actualizarCuentasVisibles() {
    var plantilla = '', tabla = this.balanceEstados ? 'balance' : 'estados';
    if(this.templateId === 4){
      plantilla = 'idsCuentasP4';
    }
    this.cuentasVisibles = [];
    const recorrer = (cuentas: any[]) => {
      cuentas.forEach(cuenta => {
        if(obtenerIds[plantilla](cuenta.codigo, tabla) !== undefined){
          if((this.sinSaldo && cuenta.presupuesto !== '-' || cuenta.real !== '-') || !this.sinSaldo){
            this.cuentasVisibles.push(cuenta);
            if (cuenta.expandido && cuenta.hijos.length > 0) {
              recorrer(cuenta.hijos);
            } 
          }
        }
      });
    };
    recorrer(this.cuentasJerarquicas);
  }

  /**
   * Se selecciona una cuenta y se realiza la consulta historica para los datos de la grafica
   * @param cuenta cuenta seleccionada 
   */
  public async cuentaSeleccionada(cuenta){
    try{
      if(cuenta !== this.cuentaSelec){
        this.cuentaSelec = cuenta;
        this.prepararDatosGrafico();
      }
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  private async prepararDatosGrafico() {
    this.datoGrafico = [];
    const idEvaEsce = this.escenariosShow.find(e => e.check)
    const evaluacionesAn: evaluacionesAllEntity = {plantillaId: this.templateId, institucionId: idEvaEsce.id};
    const escenarioDisAn =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluacionesAn));
    const periodosEsce = escenarioDisAn.slice(0,escenarioDisAn.findIndex(i => i.periodo === this.periodoSeleccionado.periodo)+1);
    const periodos = (this.Periodos.find(a => a.series.find(m => m.check))).series;
    const indiceCheck = periodos.findIndex(p => p.check);
    const ultimosPeriodos = indiceCheck === -1
      ? []
      : periodos.slice(0, indiceCheck + 1);
    this.etiquetasGrafico = ultimosPeriodos.map( p => { return `${this.translate.instant('filtros.'+p.mes)} ${p.anio}`; });

    // Inicializar arrays para los 12 meses
    let presupuestos: number[] = [];
    let reales: number[] = [];
    let metas: number[] = [];
    if(!this.balanceEstados && this.encMet == 2){
      //aqui vamos a rellenar con lo de movimientos del mes
    }
    try{
      let cuentaValor: detalleCuentaEntity;
      for(let i = 0; i < ultimosPeriodos.length; i++){
        cuentaValor = {idEvaluacion: ultimosPeriodos[i].idReal, IdCuenta: this.cuentaSelec.id}
        const r = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
        const vr = Number((r.data.detalleEvaluacionCuentas[0].valor).toFixed(2));
        reales.push(vr);
        cuentaValor = {idEvaluacion: periodosEsce[i].id, IdCuenta: this.cuentaSelec.id};
        const pr = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
        const vpr = Number((pr.data.detalleEvaluacionCuentas[0].valor).toFixed(2));
        presupuestos.push(vpr);
        //TODO: falta checar de donde se obtiene el parametro meta 
        metas.push(!isNaN((100 * vpr) / vr) ? Number(((100 * vpr) / vr).toFixed(2)) : 0);
      }
      this.datoGrafico = [
        {
          name: '% cumplimiento',
          data: metas
        },
        {
          name: 'Presupuesto',
          data: presupuestos
        },
        {
          name: this.translate.instant('segPresupuestal.estadoFinanciero.titTab4'),
          data: reales
        },      
      ];
    }catch(e){
      messages.errorMessageGraph(e.error);
      console.warn(e)
    }    
  }
  public toggleExpansion(cuenta: any) {
      cuenta.expandido = !cuenta.expandido;
      this.actualizarCuentasVisibles();
  }

  public getIndentacion(cuenta: any): string {
    if(cuenta.nivel == 1){
      return '10px'
    }else{
      return `${((cuenta.nivel - 1) * 20)+10}px`;
    }
  }

  private generarAnalisisVertical() {
    const recorrer = (cuenta, padre?): void => {
      const esRaiz = padre === undefined;
      const calcular = (valor, valorPadre): number | string => {
        if (valor === '-') {
          return '-';
        }
        if (esRaiz) {
          return 100;
        }
        if (valorPadre === '-' || valorPadre === 0) {
          return '-';
        }
        return Number(((valor / valorPadre) * 100).toFixed(2));
      };
      cuenta.analisisVerticalPresupuesto = calcular(cuenta.presupuesto, padre?.presupuesto ?? '-');
      cuenta.analisisVerticalReal = calcular(cuenta.real, padre?.real ?? '-');
      cuenta.analisisVerticalPresupuestoMov = calcular(cuenta.presupuestoMov, padre?.presupuestoMov ?? '-');
      cuenta.analisisVerticalRealMov = calcular(cuenta.realMov, padre?.realMov ?? '-');
      cuenta.hijos.forEach(hijo => recorrer(hijo, cuenta));
    };
    this.cuentasJerarquicas.forEach(cuenta => recorrer(cuenta));
  }

  private calcularVariacion(presupuesto: number | string, real: number | string): number | string {
    // Si presupuesto o real es guion, devolver guion
    if (presupuesto === '-' || real === '-') {
      return '-';
    }
    
    // Convertir a números y restar: real - presupuesto
    const numPresupuesto = Number(presupuesto);
    const numReal = Number(real);
    const variacion = Number((numReal - numPresupuesto).toFixed(2));
    
    return variacion;
  }

  private generarSemaforosParaInstitucion(): void {
    // Generar entre 3 y 5 semáforos aleatorios para la institución
    const colores = ['#4CAF50','#FF4444'];
    const min = [100, -100];
    const max = [1000, 99.9999]
    const minv = [0, 0.0111111111];
    const maxv = [-999999999999999, 999999999999999]
    
    // Semáforos para VARIACIÓN    
    for (let i = 0; i < colores.length; i++) {
      this.semaforosVariacion.push({
        min: minv[i],
        max: maxv[i],
        color: colores[i]
      });
    }

    // Semáforos para CUMPLIMIENTO (rangos de porcentaje: 0-100)
    this.semaforos = [];
    let minRangoPor = 0;
    
    for (let i = 0; i < colores.length; i++) {
      const maxRangoPor = minRangoPor + (100 / colores.length);
      this.semaforos.push({
        min: min[i],
        max: max[i],
        color: colores[i]
      });
      minRangoPor = maxRangoPor;
    }
  }

  public obtenerColorSemaforo(valor: number | string): string {
    // Si es guion o no es un número, no aplicar color
    if (valor === '-' || isNaN(Number(valor))) {
      return 'black';
    }
    const numValor = Number(valor);
    let semaforo = this.semaforos.find(s => numValor >= s.min && numValor < s.max);
    return semaforo ? semaforo.color : 'black';
  }
  private async initEscenarios() {
    try{
      //TODO: Hay que verificar el funcionamiento de las sucursales.
      let sucursalEntity: sucursalesEntity = {agrupadorId: this.idBase, tipoInstitucionId: 3};
      let res = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      this.escenarios = res.map(({ institucion, ...rest}) => ({
        name: institucion.split('|')[1],
        check: false,
        ...rest
      }))
      this.escenarios[0].check = true;
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }    
  }

  private async initSucursales() {
    try{
      let res = [];
      let sucursalEntity: sucursalesEntity =  {id: this.idBase};
      const matriz = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      this.templateId = matriz[0].plantillaId;
      let consolidado = {name: 'Consolidado', consolidado: true, check: true, id: this.idBase};
      this.sucursales.push(consolidado)
      sucursalEntity = {agrupadorId: this.idBase, tipoInstitucionId: 5};
      res = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      const resFiltro = res.filter(i => ((i.acronimo).toLowerCase()).includes('real'));
      const resEsce = res.filter(i => ((i.acronimo).toLowerCase()).includes('presupuesto'));
      const s = new Set();
      const sucur = resFiltro.map(({ institucion, ...rest}) => ({
        name: institucion.split('|')[1],
        consolidado: false,
        check: false,
        ...rest,
      })).filter( i => {
        if(s.has(i.name))
          return false;
        s.add(i.name);
        return true;
      });
      this.sucursales.push(... sucur);
      for(const suc of this.sucursales){
        if(suc.consolidado){
          suc['instEsce'] = this.escenarios;
        }else{
          const nombreSucursal = suc.name.trim().toLowerCase();

          suc.instEsce = resEsce.filter(item =>
            item.institucion.toLowerCase().includes(nombreSucursal)
          );
        }        
      }
      this.sucursalSeleccionada = this.sucursales[0];
      this.initPeriodos();
    }catch(e){
      console.warn(e)
      messages.errorMessageGraph(e.error);
    }
  }

  private async initPeriodos() {
    try{
      let evaluaciones: evaluacionesAllEntity = {plantillaId: this.templateId, institucionId: this.sucursalSeleccionada.id};
      const evaReal = await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      const info = Periodos.evaluacionesPresupuestoReal(evaReal, []);
      
      this.Periodos = info.periodos;
      this.periodoSeleccionado = info.perSeleccionado;

      evaluaciones = {plantillaId: this.templateId, periodo: this.periodoSeleccionado.periodo};
      const escenarioDis =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      this.escenariosShow = escenarioDis.filter(e => e.institucionId !== this.sucursalSeleccionada.id && e.institucion_entity.agrupadorId === this.sucursalSeleccionada.id)
        .map((e, i) => {
          return {
            name: e.institucion_entity.institucion.split(' | ')[1],
            check: i===0,
            idPresupuesto: e.id,
            ...e.institucion_entity
          }
        });
      this.escenarioSeleccionado = this.escenariosShow[0];
      this.getCuentasContables();
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }

  public async cambioPeriodo(per: any) {
    if (!per) return;
    
    // Si el objeto tiene propiedades 'mes' y 'anio', es un mes
    if (per.mes && per.anio) {
      // Actualizar solo el mes seleccionado
      this.Periodos.forEach(p => {
        if (p.series) {
          p.series.forEach(mes => {
            mes.check = (mes.mes === per.mes && mes.anio === per.anio);
          });
        }
      });
      this.periodoSeleccionado = per;
      const evaluaciones = {plantillaId: this.templateId, periodo: this.periodoSeleccionado.periodo};
      const escenarioDis =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      const eseneriosAMost = escenarioDis.filter(e => e.institucionId !== this.sucursalSeleccionada.id && e.institucion_entity.agrupadorId === this.sucursalSeleccionada.id)
      .map((e, i) => {
        return {
          name: e.institucion_entity.institucion.split(' | ')[1],
          check: i===0,
          idPresupuesto: e.id,
          ...e.institucion_entity
        }
      });

      const iguales = eseneriosAMost.length === this.escenariosShow.length &&
        eseneriosAMost.every((item, i) => item.name === this.escenariosShow[i].name);
      if(!iguales){
        this.escenariosShow = eseneriosAMost;
      }else{
        this.escenariosShow.forEach( e => {
          const es = eseneriosAMost.find(ee => ee.name === e.name);
          e.idPresupuesto = es.idPresupuesto ?? e.idPresupuesto;
        });
      }
      this.escenarioSeleccionado = this.escenariosShow.find(e => e.check);
      this.getCuentasContables();
    }
  }

  public escenarioChange(escClick: any) {
    if (!escClick || !escClick.name) return;

    this.escenariosShow.forEach(e => e.check = (e.name === escClick.name));
    const seleccionado = this.escenariosShow.find(e => e.check);
    this.escenarioSeleccionado = seleccionado;
    this.getCuentasContables();
  }

  public async sucursalChange(sucClick: any) {
    for (const suc of this.sucursales) {
      if (suc.name === sucClick.name) {
        suc.check = true;
      }else{
        suc.check = false;
      }
    }

    if (sucClick.name === 'Consolidado') {
      this.consolidado = true;
    }else{
      this.consolidado = false;
    }
    this.sucursalSeleccionada = sucClick;
    this.initPeriodos();
  }

  public resetFilters() {
    const ultimoAnio = this.Periodos[this.Periodos.length - 1];

    if (ultimoAnio) {
      this.periodoSeleccionado = ultimoAnio.series[ultimoAnio.series.length - 1];
      this.periodoSeleccionado.check = true;
    }

    for (const suc of this.sucursales) {
      suc.check = false;
    }
    this.consolidado = true;
    this.sucursales[0].check = true;
    this.sucursalSeleccionada = this.sucursales[0];

    this.perspectives = [{name: 'Vertical', check: false}];
    this.tipoGraficaActual = this.typeGrap.COMBO;
    this.estructura = false;
    this.encMet = 1;
    this.sinSaldo = false;
    this.semaforo = false;
    this.metricaSeleccionada= 'Balance general';
    this.balanceEstados = true;
    this.etiquetas = false;
    this.contraerExpandir = false;
    this.estructuraR1 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.PIE, data: [], etiquetas:[]};
    this.estructuraP1 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.PIE, data: [], etiquetas:[]};
    this.estructuraR2 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.HEATMAP, data: [], etiquetas:[]};
    this.estructuraP2 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.HEATMAP, data: [], etiquetas:[]};
    this.estructuraR3 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.PIE, data: [], etiquetas:[]};
    this.estructuraP3 = {titulo: '', filtroActivado: false, showLabels: true, tipo: this.typeGrap.PIE, data: [], etiquetas:[]};
    this.initPeriodos();
  }

  // Métodos para controles de gráfica
  public onOffLabels() {
    this.etiquetas = !this.etiquetas;
    this.changeLabel = !this.changeLabel;
  }
  public ampliarGraf(zona) {
    if(zona === 1){
      this.tituloModal = `${this.titGrafica} ${this.cuentaSelec?.nombre} | ${this.metricaSeleccionada}`;
      this.subtituloModal = `${this.periodoSeleccionado?.nombre}`
    }
    if(zona === 2){
      this.tituloModal = `${this.estructuraR1.titulo}`;
      this.subtituloModal = `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab4')} | ${this.periodoSeleccionado?.nombre}`
    }
    if(zona === 3){
      this.tituloModal = `${this.estructuraP1.titulo}`;
      this.subtituloModal = `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab3')} | ${this.periodoSeleccionado?.nombre}`
    }
    if(zona === 4){
      this.tituloModal = `${this.estructuraR2.titulo}`;
      this.subtituloModal = `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab4')} | ${this.periodoSeleccionado?.nombre}`
    }
    if(zona === 5){
      this.tituloModal = `${this.estructuraP2.titulo}`;
      this.subtituloModal = `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab3')} | ${this.periodoSeleccionado?.nombre}`
    }
    if(zona === 6){
      this.tituloModal = `${this.estructuraR3.titulo}`;
      this.subtituloModal = `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab4')} | ${this.periodoSeleccionado?.nombre}`
    }
    if(zona === 7){
      this.tituloModal = `${this.estructuraP3.titulo}`;
      this.subtituloModal = `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab3')} | ${this.periodoSeleccionado?.nombre}`
    }
    this.modalOpen = true;
    this.graficaAmp = zona;
  }
  public graficasEstructura(){    
    this.tarjetasEstructura = [];
    this.tarjetasEstructura.push(this.cuentasJerarquicas[0]);
    this.tarjetasEstructura.push(this.cuentasJerarquicas[1]);
    this.tarjetasEstructura.push(this.cuentasJerarquicas[2]);
    //Generamos datos para graficos de estructura
    this.graficaEst1();
    this.graficaEst2();
    this.graficaEst3();
  }
  private graficaEst1(){
    var dataR = [], dataP = [], etiquetas = [], extra = [];
    if(this.cuentasJerarquicas[0].hijos.length > 0){
      for(const d of this.cuentasJerarquicas[0].hijos){
        dataR.push(!isNaN(Number(d.real)) ? d.real : 0);
        dataP.push(!isNaN(Number(d.presupuesto)) ? d.presupuesto : 0);
        etiquetas.push(d.nombre);
        extra.push(d);
      }
    }
    this.estructuraR1.data = [];
    this.estructuraR1.titulo = this.cuentasJerarquicas[0].nombre;
    this.estructuraR1.data.push(
      {
        name: '',
        data: dataR,
        extra: extra,
      }
    );
    this.estructuraR1.etiquetas = etiquetas;    
    this.estructuraP1.data = [];
    this.estructuraP1.titulo = this.cuentasJerarquicas[0].nombre;
    this.estructuraP1.data.push(
      {
        name: '',
        data: dataP,
        extra: extra,
      }
    );
    this.estructuraP1.etiquetas = etiquetas;
  }
  private graficaEst2(){
    var dataR = [], dataP = [], etiquetas = [], extra = [];
    if(this.cuentasJerarquicas[1].hijos.length > 0){
      for(const d of this.cuentasJerarquicas[1].hijos){
        dataR.push(!isNaN(Number(d.real)) ? d.real : 0);
        dataP.push(!isNaN(Number(d.presupuesto)) ? d.presupuesto : 0);
        etiquetas.push(d.nombre);
        extra.push(d);
      }
    }
    this.estructuraR2.data = [];
    this.estructuraP2.data = [];
    this.estructuraR2.titulo = this.cuentasJerarquicas[1].nombre;
    this.estructuraP2.titulo = this.cuentasJerarquicas[1].nombre;
    this.estructuraR2.data.push(
      {
        name: '',
        data: dataR,
        extra: extra,
      }
    );
    this.estructuraP2.data.push(
      {
        name: '',
        data: dataP,
        extra: extra,
      }
    );
    this.estructuraR2.etiquetas = etiquetas;    
    this.estructuraP2.etiquetas = etiquetas;    
  }
  private graficaEst3(){
    var dataR = [], dataP = [], etiquetas = [], extra = [];
    if(this.cuentasJerarquicas[2].hijos.length > 0){
      for(const d of this.cuentasJerarquicas[2].hijos){
        dataR.push(!isNaN(Number(d.real)) ? d.real : 0);
        dataP.push(!isNaN(Number(d.presupuesto)) ? d.presupuesto : 0);
        etiquetas.push(d.nombre);
        extra.push(d);
      }
    }
    this.estructuraR3.data = [];
    this.estructuraP3.data = [];
    this.estructuraR3.titulo = this.cuentasJerarquicas[2].nombre;
    this.estructuraP3.titulo = this.cuentasJerarquicas[2].nombre;
    this.estructuraR3.data.push(
      {
        name: '',
        data: dataR,
        extra: extra,
      }
    );
    this.estructuraP3.data.push(
      {
        name: '',
        data: dataP,
        extra: extra,
      }
    );
    this.estructuraR3.etiquetas = etiquetas;
    this.estructuraP3.etiquetas = etiquetas;
  }
  public cambiarTipoGrafica(tipo: string) {
    this.tipoGraficaActual = tipo;
    this.cdr.detectChanges();
  }
  /**
   * @param tipo tipo de grafico del catalago
   * @param zona dato numerico que indica la zona que 
   */
  public cambiarGraficaEstructura(tipo: string, zona: number){
    if(zona === 1){
      this.estructuraR1.tipo = this.typeGrap[tipo];
    }
    if(zona === 2){
      this.estructuraP1.tipo = this.typeGrap[tipo];
    }
    if(zona === 3){
      this.estructuraR2.tipo = this.typeGrap[tipo];
    }
    if(zona === 4){
      this.estructuraP2.tipo = this.typeGrap[tipo];
    }
    if(zona === 5){
      this.estructuraR3.tipo = this.typeGrap[tipo];
    }
    if(zona === 6){
      this.estructuraP3.tipo = this.typeGrap[tipo];
    }
  }
  public filtroEstruc1(data){
    this.estructuraR1.filtroActivado = true;
    this.estructuraP1.filtroActivado = true;
    const base = this.estructuraR1.data[0].extra[data.posValue];
    if(base.hijos.length > 0){
      this.estructuraR1.data = [];
      this.estructuraP1.data = [];
      var dtR = [], dtP = [], etiquetas = [], extra = [];
      for(const d of base.hijos){
        dtR.push(!isNaN(Number(d.real)) ? d.real : 0);
        dtP.push(!isNaN(Number(d.presupuesto)) ? d.presupuesto : 0);
        etiquetas.push(d.nombre);
        extra.push(d);
      }
      this.estructuraR1.titulo = base.nombre;
      this.estructuraP1.titulo = base.nombre;
      this.estructuraR1.data.push({
        name: '',
        data: dtR,
        extra: extra
      })
      this.estructuraP1.data.push({
        name: '',
        data: dtP,
        extra: extra
      })
      this.estructuraR1.etiquetas = etiquetas;
      this.estructuraP1.etiquetas = etiquetas;
    }else{
      messages.infoMessageGraph(this.translate.instant('segPresupuestal.estadoFinanciero.swal1'))
    }
  }
  public filtroEstruc2(data){
    this.estructuraR2.filtroActivado = true;
    this.estructuraP2.filtroActivado = true;
    const base = this.estructuraR2.data[0].extra[data.posValue];
    if(base.hijos.length > 0){
      this.estructuraR2.data = [];
      this.estructuraP2.data = [];
      var dtR = [], dtP = [], etiquetas = [], extra = [];
      for(const d of base.hijos){
        dtR.push(!isNaN(Number(d.real)) ? d.real : 0);
        dtP.push(!isNaN(Number(d.presupuesto)) ? d.presupuesto : 0);
        etiquetas.push(d.nombre);
        extra.push(d);
      }
      this.estructuraR2.titulo = base.nombre;
      this.estructuraP2.titulo = base.nombre;
      this.estructuraR2.data.push({
        name: '',
        data: dtR,
        extra: extra
      })
      this.estructuraP2.data.push({
        name: '',
        data: dtP,
        extra: extra
      })
      this.estructuraR2.etiquetas = etiquetas;
      this.estructuraP2.etiquetas = etiquetas;
    }else{
      messages.infoMessageGraph(this.translate.instant('segPresupuestal.estadoFinanciero.swal1'))
    }
  }
  public filtroEstruc3(data){
    this.estructuraR3.filtroActivado = true;
    this.estructuraP3.filtroActivado = true;
    const base = this.estructuraR3.data[0].extra[data.posValue];
    if(base.hijos.length > 0){
      this.estructuraR3.data = [];
      this.estructuraP3.data = [];
      var dtR = [], dtP = [], etiquetas = [], extra = [];
      for(const d of base.hijos){
        dtR.push(!isNaN(Number(d.real)) ? d.real : 0);
        dtP.push(!isNaN(Number(d.presupuesto)) ? d.presupuesto : 0);
        etiquetas.push(d.nombre);
        extra.push(d);
      }
      this.estructuraR3.titulo = base.nombre;
      this.estructuraP3.titulo = base.nombre;
      this.estructuraR3.data.push({
        name: '',
        data: dtR,
        extra: extra
      })
      this.estructuraP3.data.push({
        name: '',
        data: dtP,
        extra: extra
      })
      this.estructuraR3.etiquetas = etiquetas;
      this.estructuraP3.etiquetas = etiquetas;
    }else{
      messages.infoMessageGraph(this.translate.instant('segPresupuestal.estadoFinanciero.swal1'))
    }
  }

  public exportarGrafica(zona) {
    var perspectiva;
    var titulos;
    if(zona === 1){
      perspectiva = this.metricaSeleccionada || 'Balance general';
      titulos = {
        titulo: perspectiva,
        subtitulo: this.periodoSeleccionado.nombre,
        nombreArch: `${perspectiva}-Estados-Financieros`
      }
    }
    if(zona === 2){
      titulos = {
        titulo: this.estructuraR1.titulo,
        subtitulo: `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab4')} | ${this.periodoSeleccionado?.nombre}`,
        nombreArch: `${this.estructuraR1.titulo} ${this.translate.instant('segPresupuestal.estadoFinanciero.titTab4')}`
      }
    }
    if(zona === 3){
      titulos = {
        titulo: this.estructuraP1.titulo,
        subtitulo: `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab3')} | ${this.periodoSeleccionado?.nombre}`,
        nombreArch: `${this.estructuraP1.titulo} ${this.translate.instant('segPresupuestal.estadoFinanciero.titTab3')}`
      }
    }
    if(zona === 4){
      titulos = {
        titulo: this.estructuraR2.titulo,
        subtitulo: `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab4')} | ${this.periodoSeleccionado?.nombre}`,
        nombreArch: `${this.estructuraR2.titulo} ${this.translate.instant('segPresupuestal.estadoFinanciero.titTab4')}`
      }
    }
    if(zona === 5){
      titulos = {
        titulo: this.estructuraP2.titulo,
        subtitulo: `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab3')} | ${this.periodoSeleccionado?.nombre}`,
        nombreArch: `${this.estructuraP2.titulo} ${this.translate.instant('segPresupuestal.estadoFinanciero.titTab3')}`
      }
    }
    if(zona === 6){
      titulos = {
        titulo: this.estructuraR3.titulo,
        subtitulo: `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab4')} | ${this.periodoSeleccionado?.nombre}`,
        nombreArch: `${this.estructuraR3.titulo} ${this.translate.instant('segPresupuestal.estadoFinanciero.titTab4')}`
      }
    }
    if(zona === 7){
      titulos = {
        titulo: this.estructuraP3.titulo,
        subtitulo: `${this.translate.instant('segPresupuestal.estadoFinanciero.titTab3')} | ${this.periodoSeleccionado?.nombre}`,
        nombreArch: `${this.estructuraP3.titulo} ${this.translate.instant('segPresupuestal.estadoFinanciero.titTab3')}`
      }
    }
    const comp = this.grafCmp.find(g => g.zona === zona)
    comp.exportImg(zona, titulos);    
  }

  // Método para manejar el cambio del análisis vertical
  public onAnalisisHorizontalChange(analisis) {
    for(const pers of this.perspectives){
      if(analisis.name === pers.name){
        pers.check = !pers.check;
      }else{
        pers.check = false;
      }
    }
  }
  // Método para manejar el cambio del filtro Sin Saldo
  public async onSinSaldoChange() {
    this.sinSaldo = !this.sinSaldo;
    this.actualizarCuentasVisibles();
  }
  //Metodo para la expansion y contraccion de todas las cuentas.
  public contraerExpandirTodo(){
    this.contraerExpandir = !this.contraerExpandir;

    const recorrer = (cuentas:any[]) => {
      cuentas.forEach(cuenta => {
        cuenta.expandido = this.contraerExpandir;
        recorrer(cuenta.hijos);
      });
    }
    recorrer(this.cuentasJerarquicas);
    this.actualizarCuentasVisibles();
  }

  // Métodos para manejar la selección de Perspectiva
  public async cambiarMetrica(metrica) {
    this.metricaSeleccionada = this.translate.instant(metrica);
    this.balanceEstados = !this.balanceEstados;
    this.estructura = !this.balanceEstados ? false : this.estructura;
    if(this.balanceEstados) this.encMet = 1;
    await this.organizarJerarquia();
    this.cuentaSelec = this.cuentasVisibles[0];
    this.prepararDatosGrafico();
  }
  public borrarFiltroEstructura(zona){
    if(zona === 1){
      this.estructuraR1.filtroActivado = false;
      this.estructuraP1.filtroActivado = false;
      this.graficaEst1();
    }
    if(zona === 2){
      this.estructuraR2.filtroActivado = false;
      this.estructuraP2.filtroActivado = false;
      this.graficaEst2();
    }
    if(zona === 3){
      this.estructuraR3.filtroActivado = false;
      this.estructuraP3.filtroActivado = false;
      this.graficaEst3();
    }
    // if(zona === 4){
    //   this.estructuraP1.filtroActivado = false;
    //   this.estructuraR1.filtroActivado = false;
    //   this.graficaEst1();
    // }
    // if(zona === 5){
    //   this.estructuraP2.filtroActivado = false;
    //   this.estructuraR2.filtroActivado = false;
    //   this.graficaEst2();
    // }
    // if(zona === 6){
    //   this.estructuraP3.filtroActivado = false;
    //   this.estructuraR3.filtroActivado = false;
    //   this.graficaEst3();
    // }
  }
  public async exportarTabla() {
    try {
      const suc = this.consolidado ? '' : this.translate.instant('segPresupuestal.estadoFinanciero.sucursal'+this.tagInstitucion);
      let titulo = `Estados Financieros - ${this.metricaSeleccionada || 'Balance general'} | ${suc} 
          ${this.sucursalSeleccionada.name} | ${this.periodoSeleccionado.nombre} | ${this.escenarioSeleccionado.name}`;
      const encabezados = ['Código', 'Descripción', 'Presupuesto'];
      const encabezados1 = ['',''];
      
      // Agregar columnas dinámicamente según análisis vertical
      if (this.perspectives[0].check) {
        encabezados.push('Presupuesto %', 'Ejecutado', 'Ejecutado %', 'Variación', 'Cumplimiento');
        if(this.encMet == 2 ){
          titulo += ` | Movimientos del mes`
          encabezados1.push(this.translate.instant('segPresupuestal.estadoFinanciero.tituloTabla3'),'','','','','',this.translate.instant('segPresupuestal.estadoFinanciero.tituloTabla2'),'','','','','')
          encabezados.push('Presupuesto', 'Presupuesto %', 'Ejecutado', 'Ejecutado %', 'Variación', 'Cumplimiento');
        }
      } else {
        encabezados.push('Ejecutado', 'Variación', 'Cumplimiento');
        if(this.encMet == 2 ){
          titulo += ` | Movimientos del mes`
          encabezados1.push(this.translate.instant('segPresupuestal.estadoFinanciero.tituloTabla3'),'','','',this.translate.instant('segPresupuestal.estadoFinanciero.tituloTabla2'),'','','')
          encabezados.push('Presupuesto', 'Ejecutado', 'Variación', 'Cumplimiento');
        }
      }
      
      await this.excelService.generateEstadosFinancierosConAnalisis(
        titulo,
        encabezados1,
        encabezados,
        this.cuentasVisibles,
        'Estados-Financieros',
        this.perspectives[0].check,
        this.semaforo,
        this.semaforosVariacion,
        this.semaforos,
        this.encMet
      );
    } catch (error) {
      messages.errorMessageGraph(this.translate.instant('segPresupuestal.estadoFinanciero.noExcel'))
    }
  }
  public async cambioConsolidadoSaldo(metSelec){
    this.encMet = metSelec;
    this.prepararDatosGrafico();
  }
}
